import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AcknowledgeDialogComponent } from '../acknowledge-dialog/acknowledge-dialog.component';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-site-access-admin',
  templateUrl: './site-access-admin.component.html',
  styleUrls: ['./site-access-admin.component.scss']
})
export class SiteAccessAdminComponent implements OnInit {
  publicAccessEnabled = true;
  inviteCode = '';
  updatedAt: string | null = null;
  updatedBy: string | null = null;
  loading = false;
  saving = false;
  validationError = '';

  constructor(private userService: UserService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.load();
  }

  get canSave(): boolean {
    if (this.saving || this.loading) return false;
    if (!this.publicAccessEnabled && !(this.inviteCode || '').trim()) return false;
    return true;
  }

  load(): void {
    this.loading = true;
    this.validationError = '';
    this.userService.getSiteAccessSettings().subscribe({
      next: (res) => {
        this.publicAccessEnabled = !!res?.publicAccessEnabled;
        this.inviteCode = res?.inviteCode || '';
        this.updatedAt = res?.updatedAt || null;
        this.updatedBy = res?.updatedBy || null;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.dialog.open(AcknowledgeDialogComponent, {
          data: `Failed to load site access settings: ${err?.error?.error || err?.error?.message || err.message}`
        });
      }
    });
  }

  onTogglePublic(enabled: boolean): void {
    this.publicAccessEnabled = enabled;
    this.validationError = '';
    if (!enabled && !(this.inviteCode || '').trim()) {
      this.validationError = 'Set a non-empty invite code before turning public access off.';
    }
  }

  save(): void {
    const code = (this.inviteCode || '').trim();
    if (!this.publicAccessEnabled && !code) {
      this.validationError = 'Set a non-empty invite code before turning public access off.';
      return;
    }
    this.saving = true;
    this.validationError = '';
    this.userService.updateSiteAccessSettings({
      publicAccessEnabled: this.publicAccessEnabled,
      inviteCode: code
    }).subscribe({
      next: (res) => {
        this.saving = false;
        this.publicAccessEnabled = !!res?.publicAccessEnabled;
        this.inviteCode = res?.inviteCode || '';
        this.updatedAt = res?.updatedAt || null;
        this.updatedBy = res?.updatedBy || null;
        this.dialog.open(AcknowledgeDialogComponent, { data: 'Site access settings saved.' });
      },
      error: (err) => {
        this.saving = false;
        const msg = err?.error?.message || err?.error?.error || err.message || 'Save failed';
        this.dialog.open(AcknowledgeDialogComponent, { data: `Save failed: ${msg}` });
      }
    });
  }
}
